.signet-checkbox {
  user-select: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;

  .checkbox-label {
    &:hover {
      cursor: pointer;
    }

    .checkbox-description {
      display: inline-block;
      vertical-align: middle;
      padding-left: 8px;

      .required {
        color: #e94040;
      }
    }
  }

  .checkbox-input {
    width: 18px;
    height: 18px;
    accent-color: var(--primary-main);
    cursor: pointer;

    &:checked + .checkbox-label:after {
      .checkbox-icon {
        background: var(--primary-main);
        border-color: var(--primary-main);
      }
    }

    &:disabled + .checkbox-label {
      cursor: not-allowed;
      opacity: 0.7;

      .checkbox-icon {
        box-shadow: none;
      }
    }
  }
}
